(ns common.loader.view
  (:require ["@mui/material/CircularProgress$default" :as CircularProgress]
            ["@mui/material/Fade$default" :as Fade]
            ["@mui/material/Modal$default" :as Modal]
            [common.loader.db]
            [re-frame.core :as rf]))

(defn loader-root []
  (let [open @(rf/subscribe [:loader/open?])]
    [:> Modal
     {:open open
      :onClose (fn [_e])
      :sx {:display "flex"
           :alignItems "center"
           :justifyContent "center"}
      :slotProps {:backdrop {:timeout 250}}}
     [:> Fade
      {:in open
       :timeout 250}
      ;; Fade children needs to be able to hold a ref and focus.
      [:> CircularProgress
       {:size 70
        :sx {:userSelect "none"}}]]]))
